// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610142054/js/" + chunkId + "." + {"44":"2b3b019c","225":"2abb4439","481":"54159bfe","486":"61640e87","770":"8f97539f"}[chunkId] + ".0.014464114221134694.chunk.js";
};